module.exports = __webpack_public_path__ + "static/media/lead-banner.e47e0a67.jpg";